import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import About from './pages/About';
import CommunityEvents from './pages/CommunityEvents';
import HalloweenCommunity from './pages/HalloweenCommunity';
import Contact from './pages/Contact';
import Experiences from './pages/Experiences';
import HolidayTrucks from './pages/HolidayTrucks';
import Home from './pages/Home';
import Games from './pages/Games';
import MentalHealth from './pages/MentalHealth';
import Neighborhood from './pages/Neighborhood';
import Nespresso from './pages/Nespresso';
import NotFound from './pages/NotFound';
const PortalDashboard = lazy(() => import('./pages/PortalDashboard'));
const PortalLogin = lazy(() => import('./pages/PortalLogin'));
import Privacy from './pages/Privacy';
import SchoolEvents from './pages/SchoolEvents';
import ServiceDetail from './pages/ServiceDetail';
const ServiceStatus = lazy(() => import('./pages/ServiceStatus'));
const PaidReceipt = lazy(() => import('./pages/PaidReceipt'));
import Services from './pages/Services';
import Terms from './pages/Terms';

const AdminCourses = lazy(() => import('./pages/AdminCourses'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const AdminVehicles = lazy(() => import('./pages/AdminVehicles'));
const AdminDocuments = lazy(() => import('./pages/AdminDocuments'));
const AdminInvoiceReview = lazy(() => import('./pages/AdminInvoiceReview'));
const BinderBuilder = lazy(() => import('./pages/BinderBuilder'));
const CourseViewer = lazy(() => import('./pages/CourseViewer'));
const LearningProfile = lazy(() => import('./pages/LearningProfile'));
const VehicleDocuments = lazy(() => import('./pages/VehicleDocuments'));
const VehicleClaim = lazy(() => import('./pages/VehicleClaim'));
const AdminClients = lazy(() => import('./pages/AdminClients'));
const AdminGames = lazy(() => import('./pages/AdminGames'));
const AdminHalloweenGallery = lazy(() => import('./pages/AdminHalloweenGallery'));
const AdminPumpkinInvoices = lazy(() => import('./pages/AdminPumpkinInvoices'));

function DeferredPage({ children }) {
  return <Suspense fallback={<div className="loading-screen"><div className="loader" /><p>Loading…</p></div>}>{children}</Suspense>;
}

export default function AppRoutes() {
  return (
      <Routes>
        {/* Invoicing has its own full-screen seasonal admin shell, not public navigation. */}
        <Route path="/admin/pumpkin-events" element={<ProtectedRoute admin><DeferredPage><AdminPumpkinInvoices /></DeferredPage></ProtectedRoute>} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/request-service" element={<Navigate to="/contact#service-request" replace />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/games" element={<Games />} />
          <Route path="/game" element={<Navigate to="/games" replace />} />
          <Route path="/halloween-holiday-trucks" element={<HolidayTrucks />} />
          <Route path="/in-the-community" element={<CommunityEvents />} />
          <Route path="/community/halloween" element={<HalloweenCommunity />} />
          <Route path="/community/halloween/donate" element={<Navigate to="/community/halloween#donate" replace />} />
          <Route path="/halloween" element={<Navigate to="/community/halloween" replace />} />
          <Route path="/school-events" element={<SchoolEvents />} />
          <Route path="/jonnys-in-your-neighborhood" element={<Neighborhood />} />
          <Route path="/jonnys-towing-x-nespresso" element={<Nespresso />} />
          <Route path="/mental-health-awareness" element={<MentalHealth />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms-conditions" element={<Terms />} />
          <Route path="/s/:token" element={<DeferredPage><ServiceStatus /></DeferredPage>} />
        <Route path="/receipt/:token" element={<DeferredPage><PaidReceipt /></DeferredPage>} />
          <Route path="/service/:token" element={<DeferredPage><ServiceStatus /></DeferredPage>} />
          <Route path="/portal/login" element={<DeferredPage><PortalLogin /></DeferredPage>} />
          <Route path="/portal/claim" element={<DeferredPage><VehicleClaim /></DeferredPage>} />
          <Route path="/claim" element={<Navigate to="/portal/claim" replace />} />
          <Route path="/employees-3YCMg" element={<Navigate to="/portal/login" replace />} />
          <Route path="/account/login" element={<Navigate to="/portal/login" replace />} />
          <Route path="/portal" element={<ProtectedRoute><DeferredPage><PortalDashboard /></DeferredPage></ProtectedRoute>} />
          <Route path="/portal/learning-profile" element={<ProtectedRoute><DeferredPage><LearningProfile /></DeferredPage></ProtectedRoute>} />
          <Route path="/portal/courses/:slug" element={<ProtectedRoute><DeferredPage><CourseViewer /></DeferredPage></ProtectedRoute>} />
          <Route path="/portal/binder" element={<ProtectedRoute><DeferredPage><BinderBuilder /></DeferredPage></ProtectedRoute>} />
          <Route path="/portal/documents" element={<ProtectedRoute><DeferredPage><VehicleDocuments /></DeferredPage></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute admin><DeferredPage><AdminDashboard /></DeferredPage></ProtectedRoute>} />
          <Route path="/admin/games" element={<ProtectedRoute admin><DeferredPage><AdminGames /></DeferredPage></ProtectedRoute>} />
          <Route path="/admin/halloween-gallery" element={<ProtectedRoute admin><DeferredPage><AdminHalloweenGallery /></DeferredPage></ProtectedRoute>} />
          <Route path="/admin/courses" element={<ProtectedRoute admin><DeferredPage><AdminCourses /></DeferredPage></ProtectedRoute>} />
          <Route path="/admin/documents" element={<ProtectedRoute admin><DeferredPage><AdminDocuments /></DeferredPage></ProtectedRoute>} />
          <Route path="/admin/invoices" element={<ProtectedRoute admin><DeferredPage><AdminInvoiceReview /></DeferredPage></ProtectedRoute>} />
          <Route path="/admin/clients" element={<ProtectedRoute admin><DeferredPage><AdminClients /></DeferredPage></ProtectedRoute>} />
          <Route path="/admin/vehicles" element={<ProtectedRoute admin><DeferredPage><AdminVehicles /></DeferredPage></ProtectedRoute>} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
  );
}
